import {
  EMP_CHECK_LIST_NEW,
  EMP_CONTRACT_NEW_EMP,
  EMP_EJIP,
  EMP_MONTHLY_NEW,
  EMP_PVD,
  EMP_TRANSFER,
  PAGE_HOLIDAY,
  PAGE_CONTRACTS,
  PAGE_SETTING,
  PIM_EMP,
  PAGE_ASSET_IT,
  PAGE_REPORT_BIRTHDAY,
  PAGE_REPORT_APPOINT,
  PAGE_REPORT_RESIGN,
  PAGE_REPORT_NEW,
  PAGE_ORG_RIGHT,
  PAGE_MENU_RIGHT,
  PAGE_INCOME_IN,
  PAGE_INCOME_OUT,
  PAGE_INCOME_KYS,
  PAGE_INCOME_DIF,
  PAGE_REPORT_LOAN_HOME,
  PAGE_INCOME_SHIFT,
  PAGE_INCOME_DILIG,
  PAGE_SETTING_CERT,
  PAGE_REPORT_ATTENDANCE,
  PAGE_REPORT_LEAVE,
  PAGE_INCOME_CERTIFICATE,
  PAGE_INCOME_PAYROLL,
  PAGE_SETTING_COST_CENTER,
  PAGE_INCOME_PAYROLL_PRINT,
  PAGE_REPORT_GUSTO,
  PAGE_REPORT_EDUCATION,
  PAGE_SETTING_LOCATION,
  PAGE_SETTING_NOTI,
  PAGE_SETTING_LEAVE,
  PAGE_REPORT_ATTENDANCE_V2,
  PAGE_SETTING_LEAVE_MAS
} from '../../../router/routes'

import fnSubListMenu from './map-3-subListmenu'
import { ReactComponent as IconEmpContact } from '../../../assets/sub_menu/icon_emp_contact.svg'
import { ReactComponent as IconEmpCheckList } from '../../../assets/sub_menu/icon_emp_chk.svg'
import { ReactComponent as IconEmpMonthly } from '../../../assets/sub_menu/icon_emp_monthly.svg'
import { ReactComponent as IconEmpPIM } from '../../../assets/sub_menu/icon_emp_PIM.svg'
import { ReactComponent as IconEmpTrsFer } from '../../../assets/sub_menu/icon_emp_trsfer.svg'
import { ReactComponent as IconEmpPVD } from '../../../assets/sub_menu/icon_emp_PVD.svg'
import { ReactComponent as IconEmpEJIP } from '../../../assets/sub_menu/icon_emp_EJIP.svg'
import { ReactComponent as IconIncIncome } from '../../../assets/sub_menu/icon_inc_inc.svg'
import { ReactComponent as IconIncDeduct } from '../../../assets/sub_menu/icon_inc_ded.svg'
import { ReactComponent as IconIncStudent } from '../../../assets/sub_menu/icon_inc_student.svg'
import { ReactComponent as IconIncHome } from '../../../assets/sub_menu/icon_inc_home.svg'
import { ReactComponent as IconIncDaily } from '../../../assets/sub_menu/icon_inc_daily.svg'
import { ReactComponent as IconIncBonus } from '../../../assets/sub_menu/icon_inc_bonus.svg'
import { ReactComponent as IconIncCer } from '../../../assets/sub_menu/icon_inc_cer.svg'
import { ReactComponent as IconIncPayroll } from '../../../assets/sub_menu/icon_inc_payroll.svg'
import { ReactComponent as IconIncPayrollP } from '../../../assets/sub_menu/icon_inc_payrollP.svg'
import { ReactComponent as IconReportNewE } from '../../../assets/sub_menu/icon_rept_newEmp.svg'
import { ReactComponent as IconReportResE } from '../../../assets/sub_menu/icon_rept_resEmp.svg'
import { ReactComponent as IconReportEmp } from '../../../assets/sub_menu/icon_rept_emp.svg'
import { ReactComponent as IconReportBirth } from '../../../assets/sub_menu/icon_rept_birth.svg'
import { ReactComponent as IconReportBorrow } from '../../../assets/sub_menu/icon_rept_borrow.svg'
import { ReactComponent as IconReportAttend } from '../../../assets/sub_menu/icon_rept_attend.svg'
import { ReactComponent as IconReportLeave } from '../../../assets/sub_menu/icon_rept_leave.svg'
import { ReactComponent as IconReportGusto } from '../../../assets/sub_menu/icon_rept_gusto.svg'
import { ReactComponent as IconReportEdu } from '../../../assets/sub_menu/icon_rept_edu.svg'
import { ReactComponent as IconSettingOrg } from '../../../assets/sub_menu/icon_set_org.svg'
import { ReactComponent as IconSettingLeave } from '../../../assets/sub_menu/icon_set_leave.svg'
import { ReactComponent as IconSettingHoli } from '../../../assets/sub_menu/icon_set_holi.svg'
import { ReactComponent as IconSettingCost } from '../../../assets/sub_menu/icon_set_cost.svg'
import { ReactComponent as IconSettingCer } from '../../../assets/sub_menu/icon_set_cer.svg'
import { ReactComponent as IconSettingCont } from '../../../assets/sub_menu/icon_set_contract.svg'
import { ReactComponent as IconSettingAsIT } from '../../../assets/sub_menu/icon_set_asIT.svg'
import { ReactComponent as IconSettingOrgR } from '../../../assets/sub_menu/icon_set_orgR.svg'
import { ReactComponent as IconSettingLocate } from '../../../assets/sub_menu/icon_set_lo.svg'
import { ReactComponent as IconSettingNoti } from '../../../assets/sub_menu/icon_set_noti.svg'
import { ReactComponent as IconSettingMenu } from '../../../assets/sub_menu/icon_set_menu.svg'

const iconSize = 20
export default function fnSubMenu(d) {
  // switch (d.sub_menu_name.toLowerCase()) {
  const fnSetObj = ({ link = null, icon = null, isBeta = false }) => {
    return {
      menuId: d.id,
      id: d.id,
      label: d.menu_sub_name,
      link,
      isBeta,
      key: d.id,
      icon,
      menuSubList:
        d.menu_sub_list && d.menu_sub_list.length > 0
          ? d.menu_sub_list.map((m, i) => {
              return fnSubListMenu(m)
            })
          : []
    }
  }
  switch (d.id) {
    // contract
    case 2:
      return fnSetObj({
        link: EMP_CONTRACT_NEW_EMP,
        icon: <IconEmpContact size={iconSize} />
      })

    // checklist
    case 3:
      return fnSetObj({
        link: EMP_CHECK_LIST_NEW,
        icon: <IconEmpCheckList size={iconSize} />
      })

    // monthly
    case 4:
      return fnSetObj({
        link: EMP_MONTHLY_NEW,
        icon: <IconEmpMonthly size={iconSize} />
      })
    // PIM
    case 5:
      return fnSetObj({
        link: PIM_EMP,
        icon: <IconEmpPIM size={iconSize} />
      })

    // provident fund
    case 6:
      return fnSetObj({ link: EMP_PVD, icon: <IconEmpPVD size={iconSize} /> })
    // ejip
    case 7:
      return fnSetObj({
        link: EMP_EJIP,
        icon: <IconEmpEJIP size={iconSize} />
      })

    // organization
    case 8:
      return fnSetObj({
        link: PAGE_SETTING,
        icon: <IconSettingOrg size={iconSize} />
      })
    // holiday
    case 9:
      return fnSetObj({
        link: PAGE_HOLIDAY,
        icon: <IconSettingHoli size={iconSize} />
      })

    // contract
    case 10:
      return fnSetObj({
        link: PAGE_CONTRACTS,
        icon: <IconSettingCont size={iconSize} />
      })
    // transfer
    case 11:
      return fnSetObj({
        link: EMP_TRANSFER,
        icon: <IconEmpTrsFer size={iconSize} />
      })

    // asset IT
    case 12:
      return fnSetObj({
        link: PAGE_ASSET_IT,
        icon: <IconSettingAsIT size={iconSize} />
      })
    // report new emp
    case 13:
      return fnSetObj({
        link: PAGE_REPORT_NEW,
        icon: <IconReportNewE size={iconSize} />
      })

    // report resign emp
    case 14:
      return fnSetObj({
        link: PAGE_REPORT_RESIGN,
        icon: <IconReportResE size={iconSize} />
      })
    // report employee
    case 15:
      return fnSetObj({
        link: PAGE_REPORT_APPOINT,
        icon: <IconReportEmp size={iconSize} />
      })

    // report birthday
    case 16:
      return fnSetObj({
        link: PAGE_REPORT_BIRTHDAY,
        icon: <IconReportBirth size={iconSize} />
      })
    // org right
    case 17:
      return fnSetObj({
        link: PAGE_ORG_RIGHT,
        icon: <IconSettingOrgR size={iconSize} />
      })

    // menu right
    case 18:
      return fnSetObj({
        link: PAGE_MENU_RIGHT,
        icon: <IconSettingMenu size={iconSize} />
      })
    case 25:
      return fnSetObj({
        link: PAGE_INCOME_IN,
        icon: <IconIncIncome size={iconSize} />
      })

    case 26:
      return fnSetObj({
        link: PAGE_INCOME_OUT,
        icon: <IconIncDeduct size={iconSize} />
      })

    case 27:
      return fnSetObj({
        link: PAGE_INCOME_KYS,
        icon: <IconIncStudent size={iconSize} />
      })

    case 28:
      return fnSetObj({
        link: PAGE_INCOME_DIF,
        icon: <IconIncHome size={iconSize} />
      })
    case 29:
      return fnSetObj({
        link: PAGE_REPORT_LOAN_HOME,
        icon: <IconReportBorrow size={iconSize} />
      })
    case 30:
      return fnSetObj({
        link: PAGE_INCOME_SHIFT,
        icon: <IconIncDaily size={iconSize} />
      })
    case 31:
      return fnSetObj({
        link: PAGE_INCOME_DILIG,
        icon: <IconIncBonus size={iconSize} />
      })
    case 32:
      return fnSetObj({
        link: PAGE_SETTING_CERT,
        icon: <IconSettingCer size={iconSize} />
      })
    case 33:
      return fnSetObj({
        link: PAGE_REPORT_ATTENDANCE,
        icon: <IconReportAttend size={iconSize} />
      })
    case 45:
      return fnSetObj({
        link: PAGE_REPORT_ATTENDANCE_V2,
        icon: <IconReportAttend size={iconSize} />
      })
    case 34:
      return fnSetObj({
        link: PAGE_REPORT_LEAVE,
        icon: <IconReportLeave size={iconSize} />
      })
    case 35:
      return fnSetObj({
        link: PAGE_INCOME_CERTIFICATE,
        icon: <IconIncCer size={iconSize} />
      })
    case 36:
      return fnSetObj({
        link: PAGE_INCOME_PAYROLL,
        icon: <IconIncPayroll size={iconSize} />
      })
    case 39:
      return fnSetObj({
        link: PAGE_INCOME_PAYROLL_PRINT,
        icon: <IconIncPayrollP size={iconSize} />
      })
    case 38:
      return fnSetObj({
        link: PAGE_SETTING_COST_CENTER,
        icon: <IconSettingCost size={iconSize} />
      })

    case 40:
      return fnSetObj({
        link: PAGE_REPORT_GUSTO,
        icon: <IconReportGusto size={iconSize} />
      })

    case 41: // leave setting
      return fnSetObj({
        link: PAGE_SETTING_LEAVE_MAS,
        icon: <IconSettingLeave size={iconSize} />
      })

    case 42:
      return fnSetObj({
        link: PAGE_REPORT_EDUCATION,
        icon: <IconReportEdu size={iconSize} />
      })

    case 43: // location setting
      return fnSetObj({
        link: PAGE_SETTING_LOCATION,
        icon: <IconSettingLocate size={iconSize} />
      })
    case 44: // location setting
      return fnSetObj({
        link: PAGE_SETTING_NOTI,
        icon: <IconSettingNoti size={iconSize} />,
        isBeta: true
      })

    default:
      return fnSetObj({ link: '/404' })
  }
}
